module.exports = __webpack_public_path__ + "media/summer_tipping_tier_1-c07e83fcd3bce56438441f9134284e7d.mp3";